import { escapeAttribute, escapeText, PROPS } from "./layout-props"

// Pure, so the schema, the v2 markdown reader and the importer all write the
// same markup without pulling Tiptap into the portal's render path.

export const UPDATE_BLOCK = new RegExp(
	`<Update${PROPS}>([\\s\\S]*?)<\\/Update>`,
	"g",
)

/** Mintlify's anchor for an update, built from its label like a heading's. */
export const updateAnchor = (label: string): string =>
	label
		.toLowerCase()
		.trim()
		.replace(/[^\p{L}\p{N}\s-]/gu, "")
		.replace(/\s+/g, "-")
		.replace(/-+/g, "-")

export const serializeUpdateTags = (tags: string[]): string | null =>
	tags.length > 0 ? JSON.stringify(tags) : null

export function parseUpdateTags(value: string | null | undefined): string[] {
	if (!value) return []
	try {
		const parsed: unknown = JSON.parse(value)
		return Array.isArray(parsed)
			? parsed.filter((tag): tag is string => typeof tag === "string")
			: []
	} catch {
		return []
	}
}

export function updateHtml({
	label,
	description,
	tags,
	contentHtml,
}: {
	label: string
	description: string
	tags: string[]
	contentHtml: string
}): string {
	const serialized = serializeUpdateTags(tags)
	const tagAttribute = serialized
		? ` data-tags="${escapeAttribute(serialized)}"`
		: ""
	return `<div data-type="update" class="pl-update"${tagAttribute}><div data-type="update-meta" class="pl-update-meta"><p data-update-label class="pl-update-label">${escapeText(
		label,
	)}</p><p data-update-description class="pl-update-description">${escapeText(
		description,
	)}</p></div><div data-type="update-content" class="pl-update-content">${
		contentHtml || "<p></p>"
	}</div></div>`
}
